import {
  CalendarTask,
  CalendarTasksGroup,
  CommonUtils,
} from '@infodata-group/inf-commons';
import { AgendaDetailedOptions } from './agenda-detailed-options';
import { AgendaDetailedCell } from './agenda-detailed-cell';

export class AgendaDetailedRow {
  public date: Date;
  public resources: CalendarTasksGroup[];
  public tasks: CalendarTask[] = [];
  public options: AgendaDetailedOptions;

  public isCurrent = false;
  public dayLabel: string;
  public dayNumber: number;
  public monthYear: string;

  public resourcesCellsDay: AgendaDetailedCell[] = [];

  constructor(
    date: Date,
    resources: CalendarTasksGroup[],
    options: AgendaDetailedOptions,
  ) {
    this.date = date;
    this.options = options;
    this.resources = resources;
    this.generateResourcesCellsDay(options);
    this.formatDate();
  }

  private generateResourcesCellsDay(options: AgendaDetailedOptions) {
    const grouped = this.resources.reduce<Record<string, CalendarTasksGroup[]>>(
      (acc, resource) => {
        if (!acc[resource['group']]) {
          acc[resource['group']] = [];
        }
        acc[resource['group']].push(resource);
        return acc;
      },
      {},
    );
    for (const group in grouped) {
      let i = 0;
      for (const resource of grouped[group]) {
        const cell = new AgendaDetailedCell(resource, this.date, options);
        if (i === grouped[group].length - 1) {
          cell.lastChild = true;
        }
        this.resourcesCellsDay.push(cell);
        i++;
      }
    }
  }

  get height(): number {
    return this.resourcesCellsDay[0].height;
  }

  formatDate() {
    this.isCurrent = CommonUtils.isToday(this.date);
    this.dayNumber = this.date.getDate();
    this.dayLabel = new Intl.DateTimeFormat('fr-FR', {
      weekday: 'long',
    }).format(this.date);
    this.monthYear = new Intl.DateTimeFormat('fr-FR', {
      month: 'short',
      year: 'numeric',
    }).format(this.date);
  }

  setTasks(tasks: CalendarTask[]) {
    this.tasks = tasks;
    for (const resourceCell of this.resourcesCellsDay) {
      const resourceTasks = tasks.filter(
        (task) => task.group.group === resourceCell.resource.id,
      );
      resourceCell.setTasks(resourceTasks);
    }
  }
}
